const BASE_URL = "https://api.wonmov.com/admin/";

export type Pagination = {
    has_more: boolean;
    next_page: number;
    previous_page: number;
    current_page: number;
    per_page: number;
    total_items: number;
    total_pages: number;
    limit: number;
};

export type ApiResponse<T> = {
    data: T | null;
    status: boolean;
    message: string;
    pagination?: Pagination
};

type ApiParams = {
    url: string;
    queryParams?: Record<string, string>;
    body?: Record<string, unknown>;
    formData?: FormData;
    headers?: HeadersInit;
    signal?: AbortSignal;
    options?: RequestInit;
};

export const api = {
    async get<T>({ url, queryParams, headers, signal, options }: ApiParams): Promise<ApiResponse<T>> {
        return api.send<T>({ url, queryParams, headers, signal, options, method: "GET" });
    },

    async post<T>({ url, body, formData, queryParams, headers, signal, options }: ApiParams): Promise<ApiResponse<T>> {
        return api.send<T>({ url, body, formData, queryParams, headers, signal, options, method: "POST" });
    },

    async put<T>({ url, body, formData, queryParams, headers, signal, options }: ApiParams): Promise<ApiResponse<T>> {
        return api.send<T>({ url, body, formData, queryParams, headers, signal, options, method: "PUT" });
    },

    async delete<T>({ url, body, formData, queryParams, headers, signal, options }: ApiParams): Promise<ApiResponse<T>> {
        return api.send<T>({ url, body, formData, queryParams, headers, signal, options, method: "DELETE" });
    },

    async send<T>({ url, body, formData, queryParams, headers, signal, options, method }: ApiParams & { method: "POST" | "PUT" | "DELETE" | "GET" }): Promise<ApiResponse<T>> {
        let requestUrl = `${BASE_URL}${url}`;
        if (queryParams) {
            requestUrl += `?${new URLSearchParams(queryParams).toString()}`;
        }
        const token = sessionStorage.getItem("token");
        const requestHeaders = new Headers(headers);
        if (!formData) {
            if (!requestHeaders.has("Content-Type")) {
                requestHeaders.set("Content-Type", "application/json");
            }
        } else {
            requestHeaders.delete("Content-Type");
        }
        if (token) {
            requestHeaders.set("Authorization", `Bearer ${token}`);
        }

        const res = await fetch(requestUrl, {
            ...options,
            headers: requestHeaders,
            method: method,
            body: formData ?? (body ? JSON.stringify(body) : undefined),
            signal: signal || undefined,
        });

        return api.parseResponse<T>(res);
    },

    async parseResponse<T>(res: Response): Promise<ApiResponse<T>> {
        let dataJson: { status: boolean; message: string | null; data: T | null, pagination?: Pagination } = await res.json();

        if (!res.ok) {
            return {
                data: null,
                status: false,
                message: dataJson.message || 'مشکلی در برقراری ارتباط با سرور وجود دارد: ' + res.statusText,
            };
        }

        let status = dataJson.status as boolean;

        if (!status) {
            let message = dataJson.message as string;
            return {
                data: null,
                status,
                message,
            };
        }

        let data = dataJson.data as T;
        let pagination = dataJson.pagination as Pagination;

        return {
            data,
            status,
            message: "",
            pagination,
        };
    },
};